export default __webpack_public_path__ + "static/media/100_15204.f3438ecc.jpg";